@if (!customerLoanList() || customerLoanList().length === 0) {
  <p>There's no loan record for this customer.</p>
  <p>Add a loan?</p>
  @if (isBranchStaff()) {
    <ng-container *ngTemplateOutlet="addLoanDropdown"></ng-container>
  }
} @else {
  <div class="row">
    <div class="col-12 col-md-4">
      <h3 class="ps-2 m-0">
        @if (sharedService.isRoles([enums.BRANCH_MANAGER, enums.BOSS, enums.FINANCE, enums.AUDITOR, enums.ADMIN])) {
          <span class="badge" [class]="totalEarning() > 0 ? 'bg-success' : 'bg-danger'">
            P&L: RM{{ totalEarning() | number: "1.2-2" }}
            @if (epfDetails() != undefined && epfDetails().Amount != undefined && sharedService.isBranchAccountHandler() == false) {
              <i class="far fa-question-circle ms-2" [ngbTooltip]="epfOverviewTooltip" style="cursor: pointer"></i>
            }
          </span>
        }
      </h3>
      <ng-template #epfOverviewTooltip>
        <div class="text-start">
          <p>
            Settlement (Include Settled): RM {{ calculateTotalSettlement(customerLoanList()) | number: "1.0-2" }}
            @if (hasSharedLoan()) {
              <!-- TODO: This will never be shown because it shows when `sharedService.isBranchAccountHandler() == false` but hasSharedLoan() role must be Branch Manager -->
              <span>/ {{ calculateTotalSettlement(allLoanList()) | number: "1.0-2" }}</span>
            }
          </p>
          <p>Ratio: {{ allLoanSettlementRatio() | number: "1.2-2" }}%</p>
        </div>
      </ng-template>
      <h3>
      @if (sharedService.isStaff()) {
        <button class="btn btn-secondary mx-1" (click)="goToSettlementLetter()" placement="top" ngbTooltip="Print Surat Penyelesaian">
          <i class="fas fa-print"></i> Print Settlement Letter
        </button>
      } @else {
        <span class="badge text-bg-info">
        @if (canPrintBankRedemptionLetter() && canPrintSettlementLetter()) {
          <div class="btn-group">
            <button class="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown"><i class="fas fa-print"></i></button>
            <ul class="dropdown-menu">
              <li (click)="goToSettlementLetter()">
                <a class="dropdown-item">Surat Penyelesaian</a>
              </li>
              <li (click)="goToBankRedemptionLetter()">
                <a class="dropdown-item">Bank Redemption Letter</a>
              </li>
            </ul>
          </div>
        } @else if (canPrintSettlementLetter()) {
          <button class="btn btn-secondary" (click)="goToSettlementLetter()" placement="top" ngbTooltip="Print Surat Penyelesaian">
            <i class="fas fa-print"></i>
          </button>
        } @else if (canPrintBankRedemptionLetter()) {
          <button class="btn btn-secondary" (click)="goToBankRedemptionLetter()" placement="top" ngbTooltip="Print Bank Redemption Letter">
            <i class="fas fa-print"></i>
          </button>
        }
          Settle: RM{{ customerLoanSettlementBalance() | number: "1.2-2" }} <i class="far fa-question-circle mx-2" [ngbTooltip]="tooltipContent" style="cursor: pointer"></i>
        </span>
      }
      </h3>
    </div>
    <div class="col-6 col-md-2 checkboxCol">
      <div class="form-check" style="width: 100% !important">
        <input type="checkbox" class="form-check-input" id="checkHideSettled" [(ngModel)]="isHidingSettled" [ngModelOptions]="{ standalone: true }" />
        <label class="form-check-label" for="checkHideSettled">Hide Settled</label>
      </div>
    </div>
    <div class="col-6 d-flex justify-content-end align-items-end p-1">
    @if (sharedService.checkIsMainShareProfile(selectedProfile()) && sharedService.isBranchManager() && sharedLoanList() != undefined) {
      <button class="btn btn-info" (click)="openSharedLoanListModal()"><i class="fas fa-hands-helping"></i> <span class="d-none d-md-inline"> Show Shared Loans</span></button>
    }
    @if (customerStatus() != enums.SETTLED_CUST && isBranchStaff()) {
      <button class="btn btn-warning" (click)="openBatchPaymentModal()"><i class="fas fa-dollar-sign"></i> <span class="d-none d-md-inline"> Batch Payment</span></button>
    }
    @if (isModal == false) {
      @if (isManagingUser()) {
        <button class="btn btn-primary" (click)="openMarkLegacyEPF()"><i class="fas fa-clipboard-check"></i> <span class="d-none d-md-inline"> Mark Legacy EPF</span></button>
        @if (customerStatus() == enums.CP_CUST) {
          <button class="btn btn-dark" (click)="confirmBeforeDownloadCPFiles()"><i class="fas fa-file-archive"></i><span class="d-none d-md-inline"> Download CP files</span></button>
        }
      }
      @if (customerStatus() !== this.enums.CP_LOAN) {
      <div class="dropdown ms-1">
          <button class="btn btn-dark dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="far fa-paper-plane"></i>Send File to</button>
          <div class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item" (click)="confirmBeforeSendCP()">
              <i class="fas fa-headset"></i> CP Dept
            </a>
          </div>
        </div>
      }
    }
    @if (isBranchStaff()) {
      <ng-container *ngTemplateOutlet="addLoanDropdown"></ng-container>
    }
    </div>
  </div>
  @if (viewCustomer() && selectedProfile()) {
    @for (loan of filteredLoanList(); track loan.ID) {
      <!-- <app-loan-card [loan]="loan" (click)="openLoanDetailsModal(loan)"></app-loan-card> -->
      <app-loan-card [loan]="loan" [reserveAmount]="selectedProfile().Reserve" [selectedCustomer]="viewCustomer()" [selectedProfile]="selectedProfile()" [needRestrictionCustomer]="isSeniorRestricted()"> </app-loan-card>
    }
  }
}

<ng-template #tooltipContent>
  <div class="text-start">
    <p>Principal: RM{{ sharedService.calculateActivePrincipal(customerLoanList()) | number: "1.2-2" }}</p>
    @if (epfDetails() != undefined && epfDetails().Amount != undefined) {
      @if (hasSharedLoan()) {
        <p>Total Settlement on EPF Date: RM{{ customerLoanSettlementBalance() | number: "1.0-2" }}<span> / {{ allLoanSettlementBalance() | number: "1.2-2" }} </span></p>
      }
      <p>Settle on {{ today() | date: "dd-MM-yyyy" }}: RM{{ epfEarlySettlement(0) | number: "1.2-2" }}
      @if (hasSharedLoan()) {
        <span> / {{ epfEarlySettlement(0, true) | number: "1.2-2" }}</span>
      }
      </p>
      <p>Settle on next month: RM{{ epfEarlySettlement(1) | number: "1.2-2" }}
      @if (hasSharedLoan()) {
        <span> / {{ epfEarlySettlement(1, true) | number: "1.2-2" }}</span>
      }
      </p>
    }
  </div>
</ng-template>

<ng-template #addLoanDropdown>
  <div class="dropdown ms-1">
  @if (selectedProfile().SharedProfileId == selectedProfile().ID || selectedProfile().SharedProfileId == undefined) {
    <button class="btn btn-info dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown"><i class="fas fa-plus"></i> Add Loan</button>
  }
    <div class="dropdown-menu dropdown-menu-end">
    @if (allowAddLoan() === true) {
      <a class="dropdown-item" (click)="checkIfLegacySettlementCompleted()">
        <i class="fas fa-hand-holding-usd fa-fw me-1"></i>Scheme Loan
      </a>
    }
    @if (allowAddEpf() && customerLoanList()?.length > 0) {
      <a class="dropdown-item" (click)="openAddSharedLoanModal()">
        <i class="far fa-handshake fa-fw me-1"></i>EPF Loan Request
      </a>
    }
    @if (allowAddLoan() === false) {
      <a class="dropdown-item" (click)="openAddLoanModal()">
        <i class="fas fa-hand-holding-usd fa-fw me-1"></i>Loan Request
      </a>
    }
    @if (allowAddEpf() && (!customerLoanList() || customerLoanList().length === 0)) {
      <a class="dropdown-item" (click)="openAddSharedLoanModal()">
        <i class="far fa-handshake fa-fw me-1"></i>EPF Loan Request
      </a>
    }
    @if (allowAddHutang()) {
      <a class="dropdown-item" (click)="openHutangLoanModal()">
        <i class="fas fa-receipt fa-fw me-1"></i>Hutang
      </a>
    }
    </div>
  </div>
</ng-template>
